export const normalizeText = (text: string) =>
  // eslint-disable-next-line no-control-regex
  text.replace(/[^\x00-\x7F]/g, "");

export const getScrollParent = (element: Element | null): Element => {
  if (!element) return document.body;
  return !["visible", "hidden"].includes(
    window.getComputedStyle(element).overflowY || ""
  ) && element.scrollHeight >= element.clientHeight
    ? element
    : getScrollParent(element.parentElement);
};

export const isOutOfView = (container: HTMLElement, element: HTMLElement) =>
  element.offsetTop < container.scrollTop ||
  element.offsetTop + element.clientHeight >
    container.scrollTop + container.clientHeight;

export const isOnView = (container: HTMLElement, element: HTMLElement) =>
  !isOutOfView(container, element);

export const isOutOfViewPort = (element: Element) => {
  const bounding = element.getBoundingClientRect();

  return (
    bounding.top < 0 ||
    bounding.left < 0 ||
    bounding.bottom >
      (window.innerHeight || document.documentElement.clientHeight) ||
    bounding.right > (window.innerWidth || document.documentElement.clientWidth)
  );
};

export const range = (start: number, stop: number, step: number = 1) =>
  Array(Math.ceil((stop - start) / step))
    .fill(start)
    .map((x, y) => x + y * step);
